import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

/** What the signed-in student can do now (plan, free hour, add-ons). The server decides; this displays. */
export function useAccess(enabled: boolean) {
  return useQuery({
    queryKey: ['billing', 'access'],
    enabled,
    queryFn: () => api.get('/api/v1/billing/access'),
    staleTime: 30_000,
  });
}
